import { render, staticRenderFns } from "./enduranceTextAdd.vue?vue&type=template&id=1af5b980&scoped=true"
import script from "./enduranceTextAdd.vue?vue&type=script&lang=js"
export * from "./enduranceTextAdd.vue?vue&type=script&lang=js"
import style0 from "./enduranceTextAdd.vue?vue&type=style&index=0&id=1af5b980&prod&lang=scss&scoped=true"
import style1 from "./enduranceTextAdd.vue?vue&type=style&index=1&id=1af5b980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af5b980",
  null
  
)

export default component.exports